/* eslint-disable react/destructuring-assignment */
import React from 'react';
import { IconButton } from '@material-ui/core';
import ReceiptIcon from '@material-ui/icons/Receipt';
import format from 'date-fns/format';

export default function (t) {
  return [
    { title: t('general.student'), field: 'studentName' },
    { title: t('general.age'), field: 'age' },
    { title: t('general.classes-names'), field: 'classNames' },
    { title: t('vaccination.vaccine'), field: 'name' },
    { title: t('vaccination.dose'), field: 'dose' },
    {
      title: t('general.status'),
      render: (rowData) => {
        if (rowData.applicationId && rowData.applicationDate) {
          return t('vaccination.applied');
        }

        if (
          rowData.age.indexOf('ano') > -1 &&
          rowData.age.indexOf('ano') <= 2
        ) {
          const convertedYears = parseInt(rowData.age.substring(0, 2), 10) * 12;
          const convertedMonths = parseInt(rowData.age.substring(7, 8), 10);

          const finalconverted = convertedYears + convertedMonths;

          if (finalconverted > rowData.targetAge) {
            return t('vaccination.late');
          }
        } else if (
          rowData.age.indexOf('ano') > -1 &&
          rowData.age.indexOf('ano') === 3
        ) {
          const convertedYears = parseInt(rowData.age.substring(0, 3), 10) * 12;
          const convertedMonths = parseInt(rowData.age.substring(8, 9), 10);

          const finalconverted = convertedYears + convertedMonths;

          if (finalconverted > rowData.targetAge) {
            return t('vaccination.late');
          }
        }
        return t('vaccination.pending');
      },
    },
    {
      title: t('vaccination.informedIn'),
      field: 'applicationDate',
      render: (rowData) => {
        if (rowData.applicationDate > 0) {
          return format(new Date(rowData.applicationDate), 'dd/MM/yyyy');
        }

        return null;
      },
    },
    { title: t('vaccination.informedBy'), field: 'appliedBy' },
    {
      title: t('vaccination.receipt'),
      field: 'fileUrl',
      render: (rowData) => {
        if (rowData.fileUrl) {
          return (
            <IconButton
              onClick={() => {
                if (rowData.fileUrl) {
                  window.open(rowData.fileUrl);
                }
              }}
            >
              <ReceiptIcon />
            </IconButton>
          );
        }
        return null;
      },
    },
  ];
}
